import api from "./api";
const API_URL = "/social-notifications";

export const   socialNotificationService = {
       async getNotifications() {
            const res = await api.get(`${API_URL}`);
            return res.data;
        },
        async markAsRead() {
            const res = await api.put(`${API_URL}/mark-read`);
            return res.data;
        }
}